import React from 'react';
import './Controls.css';

interface ControlsProps {
  currentIndex: number;
  totalCoins?: number;
  faceValue?: number;
  isRollFinished: boolean;
  hasRoll: boolean;
  disabled?: boolean;
  marketValue?: number;
  onAction: () => void;
  onQuickAction?: () => void;
}

export const Controls: React.FC<ControlsProps> = ({
  currentIndex,
  totalCoins = 25,
  faceValue = 2.00,
  isRollFinished,
  hasRoll,
  disabled = false,
  marketValue = 2.00,
  onAction,
  onQuickAction
}) => {
  if (isRollFinished) {
    return (
      <div className="btn-container">
        <button
          id="actionBtn"
          className="action-btn primary-action-btn"
          disabled={disabled}
          onClick={onAction}
        >
          Back to Bank
        </button>
      </div>
    );
  }

  if (!hasRoll) {
    return (
      <div className="btn-container">
        <button
          id="actionBtn"
          className="action-btn primary-action-btn"
          disabled={disabled}
          onClick={onAction}
        >
          Order Roll
        </button>
      </div>
    );
  }

  const isLastCoin = currentIndex >= totalCoins - 1;
  const keepText = isLastCoin ? 'Finish (Space)' : 'Keep (Space)';
  const isMarkup = marketValue > faceValue;
  const quickActionText = isMarkup
    ? `Sell €${marketValue.toFixed(2)} (S)`
    : `Deposit €${faceValue.toFixed(2)} (S)`;

  return (
    <div className="btn-container">
      {onQuickAction && (
        <button
          id="quickActionBtn"
          className="action-btn quick-action-btn"
          disabled={disabled}
          onClick={onQuickAction}
          title={isMarkup ? `Sell coin for €${marketValue.toFixed(2)}` : 'Return coin to bank for €2.00'}
        >
          {quickActionText}
        </button>
      )}

      <button
        id="actionBtn"
        className="action-btn primary-action-btn"
        disabled={disabled}
        onClick={onAction}
      >
        {keepText}
      </button>
    </div>
  );
};
